import { render, staticRenderFns } from "./ParcelOutBound.vue?vue&type=template&id=72b603a3&scoped=true"
import script from "./ParcelOutBound.vue?vue&type=script&lang=js"
export * from "./ParcelOutBound.vue?vue&type=script&lang=js"
import style0 from "./ParcelOutBound.vue?vue&type=style&index=0&id=72b603a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b603a3",
  null
  
)

export default component.exports